import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Download, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function Catalog() {
  const { t } = useTranslation();
  const pdfPath = t("catalog.pdf");
  const viewerUrl = `/web/viewer.html?file=${encodeURIComponent(pdfPath)}`;

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfPath;
    link.download = "Qianqin_Catalogue.pdf";
    link.click();
  };

  return (
    <section className="min-h-screen pt-24 pb-12 bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center gap-4 mb-12"
        >
          <Link
            to="/"
            className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:underline self-start"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            {t("nav.home")}
          </Link>
          <h4 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            {t("catalog.title")}
          </h4>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden border border-gray-200 dark:border-gray-700">
              <div className="flex items-center justify-end p-3 bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
                <button
                  onClick={handleDownload}
                  className="flex items-center space-x-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
                >
                  <Download className="w-4 h-4" />
                  <span className="hidden sm:inline">
                    {t("catalog.download")}
                  </span>
                </button>
              </div>

              <iframe
                src={viewerUrl}
                className="w-full h-[600px] md:h-[800px] rounded-b-lg"
                title="PDF Viewer"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
